import React, { useState, useEffect } from "react";
import BLButton from "../../utils/components/BLButton";
import { Link } from "react-router-dom";
import { global } from "../../App/routes";
import API, { headers } from "../../utils/API";
import ProductSlider from "../../Home/components/PopularActivities/ProductSlider";
import { currencyFormatter } from "../../utils/helper";

const AddedToCartModal = (props) => {
  const [interestingProducts, setInterestingProducts] = useState([]);

  useEffect(() => {
    if (!interestingProducts.length) {
      API.get(`interested_products?currency=${props.currency.code}`, {
        headers: { ...headers, "Accept-Language": props.lang },
      }).then((response) => {
        const { data } = response.data;

        setInterestingProducts(data);
      });
    }
  }, [interestingProducts, props.currency, props.lang]);

  const products = interestingProducts.length ? (
    <ProductSlider
      currency={props.currency}
      products={interestingProducts}
      user={props.user}
      className="added-to-cart-fix"
      slidesPerView={3}
    />
  ) : (
    ""
  );

  return (
    <div className="added-to-cart-modal">
      <div className="title-area d-flex align-items-center">
        <svg
          width="46"
          height="46"
          viewBox="0 0 46 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z"
            fill="url(#green-linear-gradient)"
          />
          <path
            d="M32.7988 14.3857L19.6659 27.8312L14.201 22.298C13.6981 21.7824 12.8811 21.7824 12.3782 22.298C11.8739 22.8136 11.8739 23.6483 12.3782 24.1626L18.7595 30.6229C19.2828 31.099 20.0654 31.1517 20.5823 30.6229L34.6228 16.2504C35.1257 15.7361 35.1257 14.9001 34.6228 14.3857C34.1187 13.8714 33.303 13.8714 32.7988 14.3857Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="green-linear-gradient"
              x1="-13.4331"
              y1="38.1728"
              x2="35.6225"
              y2="61.7231"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#80D88C" />
              <stop offset="0.601105" stopColor="#6DD498" />
              <stop offset="1" stopColor="#38CABB" />
            </linearGradient>
          </defs>
        </svg>
        {props.translate("added_to_cart_modal.added_to_cart")}
      </div>

      <div className="added-product-holder d-flex flex-column flex-lg-row justify-content-between align-items-center">
        <div className="info-area d-flex align-items-center">
          <div className="cover d-flex justify-content-center align-items-center">
            <img
              src={props.product.cover_image_url}
              alt="Product Cover"
              className="h-100"
            />
          </div>
          <div className="info">
            <h5 className="title selectable">{props.product.title}</h5>
            <div className="product-code selectable">
              {props.translate("product.product_code")}:{" "}
              <span>{props.product.code}</span>
            </div>
            <div className="location selectable">
              {`${props.product.location.town_name}, ${props.product.location.city_name}`}
            </div>
          </div>
        </div>

        <div className="control-area d-flex flex-column flex-lg-row align-items-end align-items-lg-start">
          <div className="amounts-holder d-flex flex-column align-items-end">
            <div className="amounts selectable">
              {props.item.units.map((data) => (
                <div className="amount" key={data.price_id}>
                  <div className="type">{data.name}</div>
                  <div className="count">
                    x{data.quantity}{" "}
                    {props.translate(
                      `global.${props.quantity > 1 ? `pieces` : `piece`}`
                    )}
                  </div>
                  <div className="price text-right">
                    {currencyFormatter(props.currency, data.price, props.lang)}
                  </div>
                </div>
              ))}
            </div>
            <div className="total-price selectable">
              {props.translate("global.total")}:{" "}
              <span>
                {currencyFormatter(
                  props.currency,
                  props.item.amount,
                  props.lang
                )}
              </span>
            </div>
          </div>
          <div className="buttons-holder">
            <BLButton type="pri" clicked={props.handleCloseAddedToCartModal}>
              {props.translate("added_to_cart_modal.continue_shopping")}
            </BLButton>
            <Link
              to={global.cart.links[props.lang]}
              className="go-to-cart-button d-block text-center"
            >
              {props.translate("added_to_cart_modal.pay_now")}
            </Link>
          </div>
        </div>
      </div>

      <div className="interesting-experiences-holder">
        <h6 className="title">
          {props.translate(
            "added_to_cart_modal.experiences_you_may_be_interested_in"
          )}
        </h6>
        <div className="products-holder d-flex">{products}</div>
      </div>
    </div>
  );
};

export default AddedToCartModal;
